// src/pages/SellerSuccess/StatusRenderer.jsx
import React from 'react';
import VerifyingState from './VerifyingState';
import SuccessState from './SuccessState';
import ErrorState from './ErrorState';

const StatusRenderer = ({ status, error }) => {
  switch (status) {
    case 'verifying':
      return <VerifyingState />;

    case 'success':
      return <SuccessState />;

    case 'error':
      return <ErrorState error={error} />;

    default:
      return null;
  }
};

export default StatusRenderer;